import React, { useEffect } from "react";
import { TOKENS } from "../tokens";
import { X, Gamepad2, Sparkles } from "lucide-react";

export function BreakGameModal({ isOpen, onClose, onScoreUpdated }) {
  useEffect(() => {
    function handleMessage(event) {
      if (event.data && event.data.type === "BREAK_GAME_FINISHED") {
        if (onScoreUpdated) {
          onScoreUpdated(event.data);
        }
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [onScoreUpdated]);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: "rgba(7, 19, 37, 0.85)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start", paddingTop: 80,
        justifyContent: "center",
        padding: 16,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 620,
          maxHeight: "92vh",
          backgroundColor: TOKENS.navyDeep,
          borderRadius: 20,
          border: `1px solid rgba(201, 162, 39, 0.3)`,
          boxShadow: "0 20px 50px rgba(0, 0, 0, 0.5)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div
          style={{
            padding: "14px 20px",
            background: `linear-gradient(135deg, ${TOKENS.navyMid}, ${TOKENS.navySoft})`,
            borderBottom: `1px solid rgba(255, 255, 255, 0.1)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                background: "rgba(201, 162, 39, 0.2)",
                border: `1px solid ${TOKENS.gold}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: TOKENS.goldLight,
              }}
            >
              <Gamepad2 size={20} />
            </div>
            <div>
              <div
                style={{
                  fontFamily: "Fraunces, serif",
                  fontSize: 16,
                  fontWeight: 700,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                5-Min Break Blitz
                <span
                  style={{
                    fontSize: 11,
                    background: "rgba(201, 162, 39, 0.2)",
                    color: TOKENS.goldLight,
                    padding: "2px 8px",
                    borderRadius: 12,
                    fontWeight: 600,
                  }}
                >
                  <Sparkles size={11} inline style={{ marginRight: 3, verticalAlign: "middle" }} />
                  Recharge
                </span>
              </div>
              <div style={{ fontSize: 11, color: "#9FB0C9" }}>
                Take a quick 5-min arcade break & boost your focus score
              </div>
            </div>
          </div>

          <button
            onClick={onClose}
            style={{
              background: "rgba(255, 255, 255, 0.1)",
              border: "none",
              color: "#fff",
              width: 32,
              height: 32,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            title="Close Game"
          >
            <X size={18} />
          </button>
        </div>

        {/* Game Iframe Body */}
        <div style={{ flex: 1, minHeight: 520, width: "100%", position: "relative" }}>
          <iframe
            src="/game.html"
            title="GoldPE 5-Min Break Blitz"
            style={{
              width: "100%",
              height: "100%",
              minHeight: 520,
              border: "none",
              display: "block",
            }}
          />
        </div>
      </div>
    </div>
  );
}
